'use client';

import type { CalculatorSet } from '@/components/customFields/types';
import { extractCalculatorTabFields } from '@/helper/calculatorTabFields';
import { useState } from 'react';

const useCalculatorTabs = (initialTabs: CalculatorSet) => {
  const tabs = extractCalculatorTabFields(initialTabs);
  const firstUuid = tabs[0]?.uuid ?? '';

  const [tab, setTab] = useState(firstUuid);

  return {
    tabs,
    tab,
    setTab,
  };
};

export default useCalculatorTabs;
